import { useEffect } from 'react';

export const ExternalFileThunk: React.FC = () => {
  useEffect(() => {
    window.location.reload();
  });
  return <></>;
};
export default ExternalFileThunk;
